import { useCallback } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import {clearNewOffice, newOfficePayload} from "Pages/Admin/Users/@signals"
import { useToast } from "@hooks"
import { useSignal } from "@preact/signals-react"
import { offices as idOffices } from "@signals"

export default function useCreateNewOffice() {

	const { showToast } = useToast()
	const isLoading = useSignal(false)

	const onSubmit = useCallback(() => {
		isLoading.value = true
		postSubmit(`${BACKEND_APIS.CRUD}/add`, { service_type: "offices", ...newOfficePayload.value })
			.then(({ value, error_msg }) => {
				if (!!error_msg) {
					showToast.error(error_msg)
				} else {
					idOffices.value = [value]
					clearNewOffice()
				}
				isLoading.value = false
			})
			.catch(() => {
				showToast.error("An office with the same code already exists")
				isLoading.value = false
				clearNewOffice()
			})
	}, [])

	return {
		onSubmit,
		isLoading: isLoading.value
	}
}